import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetShipmentProofsOfPickupFactoryDependencies = {
  repository: ShipmentRepository
}

export function getShipmentProofsOfPickupFactory({
  repository,
}: GetShipmentProofsOfPickupFactoryDependencies) {
  return async function getProofsOfPickup(uuid: string, config?: { signal?: AbortSignal }) {
    try {
      return await repository.getProofsOfPickup(uuid, config)
    } catch (error) {
      throw new Error('Failed to get the Proof of Pickup', { cause: error as Error })
    }
  }
}

export function getShipmentProofsOfPickup(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const get = getShipmentProofsOfPickupFactory({ repository })

  return get(id, config)
}
